// @mui
import {
  Checkbox,
  Stack,
  StackProps,
  Typography,
  useTheme,
} from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

interface Props extends StackProps {
  dense?: boolean;
  actions?: React.ReactNode;
  rowCount: number;
  numSelected: number;
  onSelectAllRows: (checked: boolean) => void;
  isNewComponent?: boolean;
}

export default function TableSelectedActions({
  dense,
  actions,
  rowCount,
  numSelected,
  onSelectAllRows,
  sx,
  isNewComponent = false,
  ...other
}: Props) {
  const { translate } = useLocales();
  const { palette } = useTheme();
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        px: 2.3,
        py: isNewComponent ? 4 : 0,
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9,
        height: 38,
        position: "absolute",
        bgcolor: isNewComponent ? palette.background.paper : "grey.400",
        ...(dense && {
          pl: 1,
          height: 38,
        }),
        ...sx,
      }}
      {...other}
    >
      {!isNewComponent && (
        <Checkbox
          size="small"
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={rowCount > 0 && numSelected === rowCount}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onSelectAllRows(event.target.checked)
          }
        />
      )}

      <Typography
        variant="subtitle1"
        sx={{
          flexGrow: 1,
          color: "primary.main",
          ...(dense && {
            ml: 3,
          }),
        }}
      >
        {numSelected} {translate(`selected`)}
      </Typography>

      {actions && actions}
    </Stack>
  );
}
